import React from 'react';
import { bool, shape, string } from 'prop-types';

const InRevision = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ ...style }} width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.64866 6.4164L7.58366 4.3514L8.40616 3.5289L9.64283 4.76557L12.1162 2.29224L12.9387 3.11474L9.64866 6.4164ZM6.41699 4.08307H1.16699V5.24974H6.41699V4.08307ZM12.2503 7.82224L11.4278 6.99974L9.91699 8.51057L8.40616 6.99974L7.58366 7.82224L9.09449 9.33307L7.58366 10.8439L8.40616 11.6664L9.91699 10.1556L11.4278 11.6664L12.2503 10.8439L10.7395 9.33307L12.2503 7.82224ZM6.41699 8.74974H1.16699V9.9164H6.41699V8.74974Z" fill="currentColor" />
  </svg>
);

InRevision.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default InRevision;
